import React from 'react'

import MarkdownHelper from '../../utils/MarkdownHelper'
import ReactMarkdown from 'react-markdown'

import ViewToggle from '../../subcomponents/ViewToggle'
import { FootnotesFromContext } from "../../subcomponents/Footnotes";

const TeaserAwardBookingConfirmationScreen = ({ campaign, isMobile, ...props }) => {
    const renderTeaserAwardBookingConfirmationScreen = (() => {
        return (
            <div className="ad-cp-teaser-award-booking-confirmation-screen bg-white border">

                <h2 className="mb-xs js-mam-symbol-content">
                    <ReactMarkdown {...MarkdownHelper.headingTypes()}
                                    source={campaign.title_2_web_short}
                                    escapeHtml={false} />
                </h2>

                <img src={campaign.image_award_booking}
                     alt="image_award_booking"
                     className="img-fluid mb-sm"/>

                <p className="copy">
                    <ReactMarkdown {...MarkdownHelper.allTypes()}
                                    source={campaign.copy_long} />
                </p>

                <div className="d-flex flex-row-reverse">
                    <button className="btn mam-rnd-btn">
                        {campaign.button_cta_external}
                    </button>
                </div>

            </div>
        )
    })()

    return (
        <div className="mam-type mam-spacers">
            <ViewToggle isMobile={isMobile('web')} desktopClasses={'desktop-view mb-md'} mobileClasses={'mobile-view mb-md'}>
                {renderTeaserAwardBookingConfirmationScreen}
                <FootnotesFromContext
                    showWarningText={props.footnotesWarningText}
                    bigIndices={props.bigIndices}
                />
            </ViewToggle>
        </div>
    )
};

export default TeaserAwardBookingConfirmationScreen;



// WEBPACK FOOTER //
// ./src/components/ads/mam/TeaserAwardBookingConfirmationScreen.js